import React from 'react';
import _ from 'lodash';

import { useAuditLogWidgetQuery } from 'generated/graphql';
import { DateTime } from 'luxon';



export interface IAuditLogEvent {
  id: string;
  title: string;
  content: string;
  createdAt: DateTime;

  triggeredByFullName: string;
  triggeredByInitials: string;
}

export interface IData {
  isSuperAdmin: boolean;
  events: IAuditLogEvent[];
}

export function useQuery({
  orderId, returnAuthorizationId
}: {
  orderId?: string;
  returnAuthorizationId?: string;
}) {
  const isQueryingOrder = !_.isNil(orderId);
  const tuple = useAuditLogWidgetQuery({
    fetchPolicy: 'network-only',
    variables: {
      id: orderId ?? returnAuthorizationId ?? '',
      isQueryingOrder
    }
  });

  return React.useMemo(() => {
    const nodes = isQueryingOrder ? tuple.data?.order?.auditLog.nodes : tuple.data?.returnAuthorization?.auditLog.nodes;
    const data: IData = {
      isSuperAdmin: tuple.data?.loggedInUser?.isSuperAdmin ?? false,
      events: _.map(nodes ?? [], (node): IAuditLogEvent => {
        const initials = _.join(_.map(_.split(node.triggeringSiteUser?.fullName ?? '', /\s+/), i => _.first(i)), '');
        return ({
          id: node.id,
          triggeredByFullName: node.triggeringSiteUser?.fullName ?? 'Interchange',
          triggeredByInitials: node.triggeringSiteUser ? initials : 'IC',
          createdAt: DateTime.fromISO(node.metaCreated),
          title: node.title,
          content: node.content
        });
      })
    };

    return {
      ...tuple,
      data
    };
  }, [
    tuple,
    isQueryingOrder
  ]);
}
